<template>
	<div id="upload">
		<van-uploader v-model="fileList" :after-read="afterRead" :max-size="30 * 1024 * 1024" @oversize="onOversize">
			<template #preview-cover="{ file }">
				<div class="preview-cover van-ellipsis">{{ file.name }}</div>
			</template>
			<div class="choose_file">
				<van-button icon="plus" type="default" class="choose_file" size="large">选择文件</van-button>
			</div>
		</van-uploader>
		<div class="submit_button">
			<van-button icon="back-top" type="primary" @click="uploadClick" :loading="isLoading" loading-text="上传中..."
				:disabled="disabled">确认上传</van-button>
		</div>
	</div>
</template>

<script>
	import request from "@/apis/request.js";
	export default {
		data() {
			return {
				fileList: [],
				fileSize: [],
				chooseFile: [],
				isLoading: false,
			};
		},
		mounted() {
			this.fileSize = []
			this.$nextTick(() => {
				document.addEventListener("UniAppJSBridgeReady", function() {
					uni.getEnv(function(res) {
						console.log("当前环境：" + JSON.stringify(res));
					});
				});
			});
		},
		computed: {
			disabled() {
				return this.fileList.length === 0
			}
		},
		methods: {
			afterRead(e) {
				// 此时可以自行将文件上传至服务器
				console.log(e, "e");
				console.log(e.file.size, "e");
				const {
					name,
					size
				} = e.file
				this.fileSize.push({
					name,
					size
				})
			},
			onOversize(file) {
				console.log(file);
				this.$toast('文件大小不能超过 30MB');
			},
			goUniappIndex(fileList) {
				uni.postMessage({
					data: {
						fileList,
					},
				});
				uni.switchTab({
					url: "/pages/index/index",
				});
			},
			uploadClick() {
				if (this.fileList.length == 0) {
					return;
				}
				let fileFormData = new FormData();
				this.fileList.forEach((item, index) => {
					fileFormData.append("files", item.file);
				});
				this.isLoading = true;
				request({
						url: "/delivery/data/upload",
						method: "POST",
						headers: {
							Authorization: this.$route.query.token,
							"Content-Type": "multipart/form-data",
						},
						data: fileFormData,
					})
					.then((res) => {
						console.log(res);
						if (res.success) {
							res.data.forEach(item => {
								let sameNameObj = this.fileSize.find(item1 => {
									return item.fileName == item1.name
								})
								if (sameNameObj != undefined) {
									item.size = sameNameObj.size
								}
							})
							this.goUniappIndex(res.data);
						}
						this.$toast(res.msg || res.data || '未知错误')
						this.isLoading = false;
					})
					.catch((err) => {
						this.isLoading = false;
						this.$toast(err)
					});
			},
		},
	};
</script>

<style>
	#upload {
		text-align: center;
		padding: 40px 20px;
	}

	.preview-cover {
		position: absolute;
		bottom: 0;
		box-sizing: border-box;
		width: 100%;
		padding: 4px;
		color: #fff;
		font-size: 12px;
		text-align: center;
		background: rgba(0, 0, 0, 0.3);
	}

	.submit_button {
		text-align: center;
		padding-top: 10px;
	}
	/* 设置按钮宽度 */
	.choose_file,.van-button--normal{
		width: calc(100vw - 20px * 2);
		height: 42px !important;
		border-radius: 10px !important;
	}
	.van-uploader__preview{
		margin: 0 10px 10px 0 !important;
		width: calc( (100vw - 20px * 2 - 30px) / 4 );
	}
	.van-uploader__preview:nth-of-type(4n){
		margin-right: 0 !important;
	}
</style>
